export const ROUTES = {
  ORDERFORM: "orderForm",
  TEMPLATE: 'template',
};
